/* eslint-disable */
import config from "../../../../config/config";
import library from "../../../../utils/Library";


const getProductsUser = (email, callback) => {
  
  const URL_JOBS_EAUTH = library.getBaseAPIUrl('e_auth_url_JOB');
  const  URL_NOTIFY_USER_EAUTH_CAC = library.getBaseAPIUrl('e_auth_notify_user_CAC');

  const requestOptionsJobs = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      key: config.KEY_JOBS,
    }),
  };

  try {
    fetch(URL_JOBS_EAUTH, requestOptionsJobs)
      .then((response) => response.json())
      .then((data) => {
        if (data?.error) return callback(null);

        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${data.jwt2}`,
          },
          body: JSON.stringify({
            email: email,
          }),
        };

        fetch(URL_NOTIFY_USER_EAUTH_CAC, requestOptions)
          .then(async (response) => {
            const data = await response.json();
            if (response.status !== 302) {
              // eslint-disable-next-line
              return callback({ code: true, api: data.api });
            }
            // eslint-disable-next-line
            const jwt = String(data.jwt2);
            // eslint-disable-next-line
            const { loginAccountData } = JSON.parse(
              // eslint-disable-next-line
              Buffer.from(
                jwt.substring(jwt.indexOf(".") + 1, jwt.lastIndexOf(".")),
                "base64",
              ).toString("utf-8"),
            );
            // eslint-disable-next-line
            callback({
              message: "ok",
              subscriptionNumber: loginAccountData?.subscriberRefId,
            });
          })

          .catch(() => callback(null));
      });
  } catch (error) {
    callback(null);
  }
};
export default getProductsUser;
